import * as React from 'react'
import { Lifebuoy } from '@phosphor-icons/react'
import { trackEvent } from 'app/packs/src/services/event-tracker'
import {
  EVENT_KEY_NAME,
  KNOWLEDGE_BASE_URL,
} from 'components/get-started-modal/shared'

export const GetHelp = () => (
  <a
    target="_blank"
    href={KNOWLEDGE_BASE_URL}
    onClick={() => {
      trackEvent(EVENT_KEY_NAME, {
        title: 'Get help from our team',
        href: KNOWLEDGE_BASE_URL,
      })
    }}
    className="flex-1 flex flex-row gap-x-4 items-center border-px border-solid border-gray-100 hover:border-gray-200 rounded-lg p-4 transition-colors"
    rel="noopener noreferrer"
  >
    <div className="rounded bg-pink-100 text-pink-600 w-20 flex-shrink-0 h-full flex items-center justify-center">
      <Lifebuoy aria-hidden weight="bold" size="24" />
    </div>
    <div className="flex flex-col gap-y-1">
      <h3 className="font-bold text-gray-900 text-sm">
        Get help from our team
      </h3>
      <p className="text-gray-600 text-xs mb-0">
        Browse step-by-step guides and answers to common questions in our
        Knowledge Base.
      </p>
    </div>
  </a>
)
